import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { toStyled } from '@drone-js/media-query';
import { useExperimentContext } from '../../contexts/session/Experiment.js';
import styled from 'styled-components';
import { COLUMNCOUNT } from './Grid.config.js';

var _excluded = ["sm", "md", "lg", "xl", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var propTransform = function propTransform(size, gridSizeFallback) {
  if (size === 'none') {
    return {
      $css: {
        display: 'none'
      }
    };
  }
  if (gridSizeFallback && !size) return {
    $css: undefined
  };
  var columnWidth = size ? "".concat(size * 100 / COLUMNCOUNT, "%") : '100%';
  return {
    $css: {
      display: 'flex',
      maxWidth: columnWidth,
      flexBasis: columnWidth
    }
  };
};
var GridItemStyled = /*#__PURE__*/styled.div.withConfig({
  displayName: "GridItem__GridItemStyled",
  componentId: "sc-3btv1u-0"
})(function (props) {
  return _objectSpread(_objectSpread({
    flex: '2 1 0',
    flexDirection: 'column'
  }, props.$css), props.$q);
});
var GridItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var sm = props.sm,
    md = props.md,
    lg = props.lg,
    xl = props.xl,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var _useExperimentContext = useExperimentContext(),
    gridSizeFallback = _useExperimentContext.gridSizeFallback;
  var defaultStyledProps = propTransform(sm, gridSizeFallback);
  var propsToQueryProps = {
    qXl: propTransform(xl, gridSizeFallback).$css,
    qL: propTransform(lg, gridSizeFallback).$css,
    qM: propTransform(md, gridSizeFallback).$css
  };
  var q = toStyled(propsToQueryProps, function (queryProps) {
    return queryProps;
  });
  return /*#__PURE__*/React.createElement(GridItemStyled, _extends({}, rest, {
    ref: ref,
    $q: q
  }, defaultStyledProps), children);
});
var GridItemMemoized = /*#__PURE__*/React.memo(GridItem);
GridItemMemoized.displayName = 'GridItem';

export { GridItemMemoized as GridItem, GridItemStyled };
//# sourceMappingURL=GridItem.js.map
